import React from "react";
import branding from "../../branding.json";

export default function Brand({ compact = false }) {
  return <span className="tw-inline-flex tw-items-center tw-gap-3">
    <img src={branding.icon} alt={branding.name} width={44} height={44} className="tw-block tw-h-11 tw-w-11 tw-shrink-0 tw-object-contain" />
    {!compact && <span className="tw-text-xl tw-font-semibold tw-tracking-tight tw-text-messenger-ink dark:tw-text-green-100">{branding.name}</span>}
  </span>;
}
